module.exports = __webpack_public_path__ + "img/congratulation-bg.86f405ce.svg";